module.exports = __webpack_public_path__ + "static/chan1-0331562f58c150e4911bc4150a9068de.webp";